<template>
    <c-dialog ref="dialog" title="外协招工详情" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.recruit_number" class="m-detail-tag flex-center-cross">
                <label>{{detailData.recruit_number}}</label>
                <c-state v-if="detailData.urgency_level != 1" dict="urgencyLevelDic" tag :value="detailData.urgency_level"></c-state>
                <c-state dict="applyStatusDic" tag :value="detailData.status"></c-state>
            </div>
        </template>
        
		<doc-base>
			<template #title>{{detailData.create_user_realname}}_外协招工申请</template>

			<template #info>
				<c-field>{{detailData.customer_name}}</c-field>
				<c-field label="单据编号">{{detailData.recruit_number}}</c-field>
			</template>
		</doc-base>

		<doc-content>
			<c-field label="关联工单">{{detailData.order_number}}</c-field>
			<c-field label="招工类型"><c-state dict="recruitTypeDic" :value="detailData.recruit_type"></c-state></c-field>
			<c-field label="招工人数">{{detailData.recruit_count}}人</c-field>
			<c-field label="上班天数">{{detailData.work_days}}天</c-field>
			<c-field label="所需费用"><b style="color: #f00;">￥{{detailData.required_fee}}</b></c-field>
			<c-field label="人员到岗时间">{{detailData.arrival_time}}</c-field>
			<c-field label="备注">{{detailData.remark}}</c-field>
		</doc-content>

		<doc-log ref="docLog"></doc-log>

		<doc-handle
			ref="docHandle"
			:status="detailData.status"
			:applicant="detailData.is_founder == 1"
			:approver="detailData.is_approval == 1"
			@update="onHandleUpdate"
		></doc-handle>
    </c-dialog>
</template>

<script>
export default {
    name: 'outsourceRrecruitDetail',

    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {}
        }
    },

    methods: {
        open() {
            this.update();
            this.$refs.dialog.open();
        },

        onHandleUpdate() {
            this.update();
            this.$bus.$emit('outsource_recruit_list.update');
        },

        update() {
            this.request({
                url: '/outsource/recruit/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data.detailInfo;
                    this.$refs.docLog.init(data.detailInfo.form_id);
                    this.$refs.docHandle.init(data.transaction);
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>